import styled from "styled-components";
import { device } from "../../device";

export const StandardTextContainer = styled.div`
  display: flex;
  height: auto;
  position: relative;
  z-index: 2;
  ${({ backgroundImage, backgroundImageFile, backgroundColor }) => {
    switch (backgroundImage) {
      case true:
        return `
        background-image: ${`url(${require(`../../images/${backgroundImageFile}`)})`};
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 50px 0;
      `;
      default:
        return `
      flex-direction: column;
      justify-content: center;
      align-items: center;  
      padding: 50px 0;
      background: ${backgroundColor};
      `;
    }
  }}

  @media ${device.tablet} {
    padding: 4rem 0;
  }

  @media ${device.laptop} {
    min-height: calc(75vh - 80px);
    padding: 3rem 0;
  }
`;

export const BackgroundEffectContainer = styled.div`
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
  left: 50%;
  display: none;
  z-index: -1;

  @media ${device.tablet} {
    display: flex;
  }
`;

export const BackgroundLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  filter: ${(props) => props.logoBrightness};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1350px;
  height: auto;
  max-height: calc(100% - 3rem);
  margin: auto;
  align-items: centre;
  width: 80%;
  animation-name: fade-in;
  animation-timeline: view();

  @keyframes fade-in {
    from {
      scale: 0.8;
      opacity: 0;
    }
    to {
      scale: 1;
      opacity: 1:
    }
  }

  @media ${device.laptopL} {
    max-height: calc(80% - 3rem);
  }
`;

export const HeadingWrapper = styled.div`
  margin: auto;
  width: 100%;

  @media ${device.tablet} {
    padding-bottom: 0.5rem;
  }

  @media ${device.laptop} {
    padding-bottom: 1rem;
  }

  @media ${device.laptopL} {
    padding-bottom: 2rem;
  }
`;

export const Heading = styled.h1`
  text-align: center;
  margin-bottom: 24px;
  font-size: 2rem;
  line-height: 1.1;
  font-weight: 600;
  color: ${(props) => props.textColor};

  @media ${device.mobileL} {
    font-size: 3rem;
  }
`;

export const TextWrapper = styled.div`
  margin: auto;
`;

export const Text = styled.p`
  text-align: center;
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin-bottom: 2rem;
  color: ${(props) => props.textColor};

  @media ${device.tablet} {
    font-size: 1.25rem;
  }
`;

export const Paragraph = styled.p`
  text-align: center;
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: ${(props) => props.textColor};

  @media ${device.tablet} {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-bottom: 1.25rem;
  }
`;
